import { useEffect, useState } from "react";
import { fetchAuthSession } from "aws-amplify/auth";

/**
 * Pull the `cognito:groups` claim from the current ID token. Returns an
 * empty array when signed out or when the claim is missing. The server is
 * the real authority — this is purely for hiding/showing admin UI.
 */
async function readGroupsFromIdToken(): Promise<string[]> {
  try {
    const session = await fetchAuthSession();
    const claim = session.tokens?.idToken?.payload["cognito:groups"];
    if (Array.isArray(claim)) {
      return claim.filter((g): g is string => typeof g === "string");
    }
    if (typeof claim === "string") {
      return [claim];
    }
    return [];
  } catch {
    return [];
  }
}

export function useIsAdmin(): { loading: boolean; isAdmin: boolean } {
  const [loading, setLoading] = useState(true);
  const [isAdmin, setIsAdmin] = useState(false);
  useEffect(() => {
    let cancelled = false;
    void readGroupsFromIdToken().then((groups) => {
      if (cancelled) return;
      setIsAdmin(groups.includes("admins"));
      setLoading(false);
    });
    return () => {
      cancelled = true;
    };
  }, []);
  return { loading, isAdmin };
}
